import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Modal, Button, Colors } from 'advenio-components'
import DocumentsActions from '../../../Data/Redux/DocumentsRedux'
import Step1SelectDocuments from './Step1SelectDocuments'
import Step2SelectStudents from './Step2SelectStudents'
import Step3Confirm from './Step3Confirm'

var ModalBody = styled.div`
  min-height: 500px;
  display: flex;
  flex-direction: column;
`

var StepIndicator = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid ${Colors.gray200};
  font-size: 14px;
  font-weight: 600;
  color: #637381;
`

var StepContent = styled.div`
  flex: 1;
  padding: 24px;
  overflow-y: auto;
`

var Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-top: 1px solid ${Colors.gray200};
`

var FooterLeft = styled.div`
  display: flex;
  gap: 8px;
`

var FooterRight = styled.div`
  display: flex;
  gap: 8px;
`

class DistributeWizard extends Component {
  handleNext = () => {
    this.props.nextStep()
  }

  handlePrev = () => {
    this.props.prevStep()
  }

  handleClose = () => {
    this.props.closeWizard()
  }

  canGoNext = () => {
    var currentStep = this.props.currentStep
    if (currentStep === 1) {
      return this.props.selectedDocuments.length > 0
    }
    if (currentStep === 2) {
      return this.props.selectedStudents.length > 0
    }
    return true
  }

  renderStepContent = () => {
    var currentStep = this.props.currentStep
    if (currentStep === 1) {
      return <Step1SelectDocuments />
    }
    if (currentStep === 2) {
      return <Step2SelectStudents />
    }
    if (currentStep === 3) {
      return <Step3Confirm />
    }
    return null
  }

  render () {
    var isOpen = this.props.isOpen
    var currentStep = this.props.currentStep
    var distributing = this.props.distributing

    if (!isOpen) return null

    return (
      <Modal
        isOpened={isOpen}
        onClose={this.handleClose}
        title='Distribuir Documentos'
        customWidth='900px'
      >
        <ModalBody>
          <StepIndicator>
            {'Paso ' + currentStep + ' de 3'}
          </StepIndicator>
          <StepContent>
            {this.renderStepContent()}
          </StepContent>
          <Footer>
            <FooterLeft>
              {currentStep > 1 && (
                <Button
                  default
                  onClick={this.handlePrev}
                  disabled={distributing}
                >
                  Atrás
                </Button>
              )}
            </FooterLeft>
            <FooterRight>
              <Button
                default
                onClick={this.handleClose}
                disabled={distributing}
              >
                Cancelar
              </Button>
              {currentStep < 3 && (
                <Button
                  primary
                  onClick={this.handleNext}
                  disabled={!this.canGoNext()}
                >
                  Siguiente
                </Button>
              )}
            </FooterRight>
          </Footer>
        </ModalBody>
      </Modal>
    )
  }
}

DistributeWizard.propTypes = {
  isOpen: PropTypes.bool,
  currentStep: PropTypes.number,
  selectedDocuments: PropTypes.array,
  selectedStudents: PropTypes.array,
  distributing: PropTypes.bool,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  closeWizard: PropTypes.func.isRequired
}

DistributeWizard.defaultProps = {
  isOpen: false,
  currentStep: 1,
  selectedDocuments: [],
  selectedStudents: [],
  distributing: false
}

var mapStateToProps = function (state) {
  return {
    isOpen: state.documents.wizard.isOpen,
    currentStep: state.documents.wizard.currentStep,
    selectedDocuments: state.documents.wizard.selectedDocuments,
    selectedStudents: state.documents.wizard.selectedStudents,
    distributing: state.documents.wizard.distributing
  }
}

var mapDispatchToProps = function (dispatch) {
  return {
    nextStep: function () { return dispatch(DocumentsActions.nextStep()) },
    prevStep: function () { return dispatch(DocumentsActions.prevStep()) },
    closeWizard: function () { return dispatch(DocumentsActions.closeWizard()) }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DistributeWizard)



// WEBPACK FOOTER //
// ./src/Containers/Documents/DistributeWizard/index.jsx